<template>
    <label
      v-if="label"
      :for="id"
      class="label-form"
      :class="{ 'text-red-700 dark:text-red-500': hasError }">
      <div class="flex flex-wrap items-center my-1">
        <span>{{ label }}</span>
        <em v-if="isRequired" class="not-italic text-red-500">*</em>
      </div>
    </label>
  
    <v-select
      :options="data"
      :placeholder="placeholder"
      v-model="value"
      :class="{
        ' bg-red-50 py-0 m-0 border border-red-500 text-red-900 placeholder-red-700 rounded-lg focus:ring-red-500 focus:border-red-500 block w-full dark:bg-red-100 dark:border-red-400':
          hasError,
      }"
      :getOptionLabel="setLabel"
      :reduce="setCode"
      :loading="isLoading"
      :disabled="disabled">
      <template #option="option">
        <component 
                :is="template" 
                :option="option" 
                v-if="template" />
      </template>
    </v-select>
  
    <p
      class="mt-1 text-xs text-red-600 dark:text-red-500"
      v-for="error in validate?.$errors"
      :key="error.$uid"
    >
      {{ error.$message }}
    </p>
  </template>
  
  <script setup>
  import { computed, defineProps, defineEmits } from "vue";
  
  const emit = defineEmits(["update:modelValue", "change"]);
  
  const props = defineProps({
    id: {
      type: String,
      required: true,
    },
    label: {
      required: false,
      type: String,
    },
    data: {
      type: Array,
      default: () => [],
    },
    validate: {
      type: Object,
      default: () => {},
    },
    modelValue: null,
    isLoading: {
      type: Boolean,
      default: false,
    },
    setLabel: {
      type: Function,
    },
    setCode: {
      type: Function,
      default: () => {},
    },
    template: null,
    placeholder: {
      type: String,
      default: () => "Select an option",
    },
    disabled: {
      type: Boolean,
      default: () => false,
    }
  });
  
  const hasError = computed(() => props.validate?.$errors?.length > 0);
  const isRequired = computed(() => !!props.validate?.required);
  
  const value = computed({
    get() {
      return props.modelValue;
    },
    set(value) {
      emit("update:modelValue", value);
      emit("change", value);
    },
  });
  </script>
  
<style lang="scss">
.vs__search::placeholder,
.vs__dropdown-toggle,
.vs__dropdown-menu {
  @apply px-1 py-1 my-0 rounded-lg w-full border border-gray-200 placeholder-gray-50 focus:outline-none text-xs font-light text-gray-600;
}

.vs__search::placeholder{
  @apply text-gray-500;
}
</style>